import { UIGameTimedAnimation } from './UIGameTimedAnimation.ts';
export class UIGameFlickerAnimation extends UIGameTimedAnimation {
    updateAnimation(deltaTime, elapsedMS) {
        const { minOpacity, maxOpacity, speed } = this.options;
        const animationProgress = this.totalElapsedMS / 1000 * speed;
        const opacityRange = maxOpacity - minOpacity;
        const sineWaveValue = Math.sin(animationProgress * Math.PI * 2 - Math.PI / 2);
        const opacityOffset = (sineWaveValue * opacityRange + opacityRange) / 2;
        const currentOpacity = minOpacity + opacityOffset;
        this.viewToAnimate.alpha = currentOpacity;
    }
    resetToDefaultState() {
        this.viewToAnimate.alpha = this.options.maxOpacity;
    }
    static getDefaultOptions() {
        return {
            minOpacity: 0.5,
            maxOpacity: 1,
            speed: 1.2
        };
    }
    constructor(viewToAnimate, animationDuration = 2000, options){
        super(animationDuration), this.forceEnableAnimation = true;
        this.viewToAnimate = viewToAnimate;
        this.options = options !== null && options !== void 0 ? options : UIGameFlickerAnimation.getDefaultOptions();
    }
}
